import { commodityTypes } from './actionTypes';

export const getCommodityList = (payload: any) => ({
  type: commodityTypes.GET_COMMODITY_DEFINITIONS,
  payload,
});

export const getCommodityListSuccess = (payload: any) => ({
  type: commodityTypes.GET_COMMODITY_SUCCESS,
  payload,
});

export const getCommodityListFail = (error: any) => ({
  type: commodityTypes.GET_COMMODITY_FAIL,
  payload: error,
});
export const getCommodityListByGUID = (payload: any) => {
  return {
    type: commodityTypes.GET_COMMODITY_BY_GUID_DEFINITIONS,
    payload,
  };
};

export const getCommodityListByGUIDSuccess = (payload: any) => ({
  type: commodityTypes.GET_COMMODITY_BY_GUID_SUCCESS,
  payload,
});

export const getCommodityListByGUIDFail = (error: any) => ({
  type: commodityTypes.GET_COMMODITY_BY_GUID_FAIL,
  payload: error,
});
export const getGroupName = (payload: any) => {
  return {
    type: commodityTypes.GET_GROUPNAME,
    payload,
  };
};

export const getMilestoneConfigCommodity = ()=>{
  return{
    type: commodityTypes.GET_MILESTONESCONFIG_COMMODITY,
  }
}

export const getMilestoneConfigCommoditySuccess = (payload:any)=>{
  return{
    type: commodityTypes.GET_MILESTONESCONFIG_COMMODITY_SUCCESSS,
    payload,
  }
}

export const getMilestoneConfigCommodityFail = (payload:any)=>{
  return{
    type: commodityTypes.GET_MILESTONESCONFIG_COMMODITY_FAIL,
    payload,
  }
}

//-------------------PACKING LIST--------------------------------
export const getPackingListgCommodity = (payload:any)=>{
  return{
    type: commodityTypes.GET_PACKINGLIST_COMMODITY,
    payload,
  }
}

export const getPackingListCommoditySuccess = (payload:any)=>{
  return{
    type: commodityTypes.GET_PACKINGLIST_COMMODITY_SUCCESSS,
    payload,
  }
}

export const getPackingListCommodityFail = (payload:any)=>{
  return{
    type: commodityTypes.GET_PACKINGLIST_COMMODITY_FAIL,
    payload,
  }
}